import { render, staticRenderFns } from "./ProfessorVinculoCard.vue?vue&type=template&id=d09a9a72&scoped=true"
import script from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"
export * from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessorVinculoCard.vue?vue&type=style&index=0&id=d09a9a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09a9a72",
  null
  
)

export default component.exports